import React from 'react'
import { AppInput } from '../../ui'

export const Input = React.forwardRef<
  unknown,
  React.ComponentProps<typeof AppInput>
>((props, ref) => {
  return <AppInput {...props} ref={ref} />
})
